import { render, staticRenderFns } from "./PlatonFormElement.vue?vue&type=template&id=8294ccf4&"
import script from "./PlatonFormElement.vue?vue&type=script&lang=js&"
export * from "./PlatonFormElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports